/* eslint-disable no-unused-expressions */
import axios from 'axios';
import { isObject, getObjMultiLevelValue } from '../js/utils';
import Toast from '../components/toast/Toast';

const postContentType = 'application/json;charset=utf-8';

/**
 * 自定义axios实例，添加自定义深度拦截
 */
const instance = axios.create({
  timeout: 60000,
  headers: {
    post: {
      'Content-Type': postContentType
    }
  },
  responseType: 'json',
  transformRequest: [function (data, headers) {
    if (
      headers.post['Content-Type'] === postContentType
    ) {
      return isObject(data) ? JSON.stringify(data) : data;
    }

    return data;
  }]
});

instance.interceptors.request.use((config) => {
  // Do something before request is sent
  return config;
}, (error) => {
  // Do something with request error
  return Promise.reject(error);
});

instance.interceptors.response.use((response) => {
  // 后台自定义的返回码，e.g.常用的errcode
  const {
    statusKey,
    statusValue,
    msgKey,
    dataKey,
    toastError = true
  } = response.config;
  const result = response.data;
  const code = statusKey ? getObjMultiLevelValue(result, statusKey) : null;

  if (result === false) {
    Toast.fail('登陆过期，请重新登陆后进入该页面');
    return Promise.reject(new Error('登陆过期'));
  }

  if (statusKey && code !== statusValue) {
    const errMsg = getObjMultiLevelValue(result, msgKey);
    toastError && Toast.fail(errMsg);
    const err = new Error(msgKey ? errMsg : `错误码:${code}`);
    err.code = code;
    err.originData = result;
    return Promise.reject(result);
  }

  return Promise.resolve(dataKey ? getObjMultiLevelValue(result, dataKey) : result);
}, (error) => {
  Toast.fail(error);
  // Do something with response error
  return Promise.reject(error);
});

export default instance;
